// Client-модели REST-контракта warehouse (зеркалят бэковые client-DTO из
// services/modifiersets/warehouse/v1/models/client). БД-модели фронт не видит.

export enum ModifierSetTypeDto {
    ChooseOne = "ChooseOne",
    ChooseMany = "ChooseMany",
}

export enum IikoModifierSetTypeDto {
    PriceSize = "PriceSize",
    Modifiers = "Modifiers",
    GroupModifiers = "GroupModifiers",
}

export interface ModifierPriceDto {
    currencyId: string;
    price: number;
}

export interface ModifierDto {
    id: string;
    name: Record<string, string>;
    sellPrice: ModifierPriceDto;
    isInStopList: boolean;
    externalId: string | null;
}

export interface ExternalModifierSettingsDto {
    integrationType: string;
    type: IikoModifierSetTypeDto;
    isCommonCompoundModifier: boolean;
}

// Поля неактуального типа набора приходят нулевыми (isRequired у ChooseMany,
// min/maxCountTotalChosen у ChooseOne) — так же, как в бэковом DTO.
export interface ModifierSetDto {
    id: number;
    type: ModifierSetTypeDto;
    name: Record<string, string>;
    modifiers: ModifierDto[];
    isRequired: boolean;
    minCountTotalChosen: number;
    maxCountTotalChosen: number;
    externalId: string | null;
    externalSettings: ExternalModifierSettingsDto | null;
}
